function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#e2e5e7}.cls-2{fill:#b0b7bd}.cls-3{fill:#cad1d8}.cls-4{fill:#566d7f}.cls-5{font-size:13.35px;fill:#fff;font-family:proxima-nova;font-weight:700}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "file-BCF");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "cls-1",
  d: "M81.87 22.29v65.05a4.76 4.76 0 0 1-4.76 4.76H17.78A4.76 4.76 0 0 1 13 87.34V4.76A4.76 4.76 0 0 1 17.78 0h41.46z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M63.6 22.29h18.27L59.24 0l.09 18a4.27 4.27 0 0 0 4.27 4.29z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M63.59 22.29h18.28V40.3L63.59 22.29z"
}), React.createElement("rect", {
  className: "cls-4",
  y: 43.09,
  width: 68.9,
  height: 34.42,
  rx: 4.71,
  ry: 4.71
}), React.createElement("path", {
  className: "cls-3",
  d: "M65.51 77.51H13v2.4h52.51a3.39 3.39 0 0 0 3.39-3.39v-2.39a3.38 3.38 0 0 1-3.39 3.38z"
}), React.createElement("text", {
  className: "cls-5",
  transform: "translate(21.98 65.52)"
}, "BCF")));

var SvgIconBcf = function SvgIconBcf(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 81.87 92.1",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconBcf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-bcf.e5012170.svg";
export { ForwardRef as ReactComponent };